import accountBalance from "../../models/gestionEmpleados/empleados/accountBalance";
import accountBalanceHistory from "../../models/gestionEmpleados/empleados/accountBalanceHistory";
import service from "../../services/gestionEmpleados/accountBalances";

export default {
  namespaced: true,
  state: {
    service: new service(),
    accountBalances: [],
    accountBalanceHistory: [],
    edit: [],
    new: [],
    deleteItem: [],
  },

  mutations: {
    setAccountBalances(state, data) {
      state.accountBalances = data;
    },
    setAccountBalancesHistory(state, data) {
      state.accountBalanceHistory = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
  },
  actions: {
    async getAccountBalances({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getAccountBalances();
          commit("setAccountBalances", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getAccountBalanceHistory({ state, dispatch, commit }, data) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getAccountBalanceHistory(data);
          commit("setAccountBalancesHistory", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    async edit({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.edit(state.edit).then(() => {
            let item = state.edit;

            commit("setEdit", item);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async new({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.new(state.new).then(() => {
            let item = state.new;
            let options = state.accountBalances;
            let newItem = accountBalance.fromJson({
              conceptoId: item.conceptoId,
              nomConcepto: item.name,
              cantidad: item.amount,
              aplicaEn: item.appliesIn,
            });
            options.push(newItem);
            commit("setAccountBalances", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async newMovim({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.newMovim(state.new).then(() => {
            let item = state.new;
            let options = state.accountBalanceHistory;
            let newItem = accountBalanceHistory.fromJson({
              movimId: item.movimId,
              fecha: item.fecha,
              empId: item.empId,
              conceptoId: item.conceptoId,
              nomConcepto: item.nomConcepto,
              cantidad: item.cantidad,
              saldo: item.saldo,
              operId: item.operId,
              nomOper: item.nomOper,
            });
            options.push(newItem);
            commit("setAccountBalancesHistory", options);
            dispatch("getAccountBalances");
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async delete({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.delete(state.deleteItem).then(() => {
            const deleteitem = state.deleteItem;
            commit("setDeleteItem", deleteitem);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
